import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PortalSalesAgentNode } from '@app/services/api/api.types';

@Component({
  selector: 'reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewsComponent {
  @Input() salesAgent: PortalSalesAgentNode;
}
